/**
 * @file 语音合成服务
 * @author fuqiang15
 */

import FormModel from '../BaseFormModel';
import {pick} from 'lodash';

export default class AudioServiceFormModel extends FormModel {
    /**
     * @override
     */
    title = '';
    serviceType = 'audio';

    text = '';

    audioDemo = null;

    languageMap = Object.freeze(this.getConstantMap('LAN'));
    timbreMap = Object.freeze(this.getConstantMap('TIMBRE'));

    init() {
        super.init();

        this.demoRequester = this.api.appServiceAudioDemo;
    }

    adaptData(data) {
        super.adaptData(data);
        this.text = data.data.text;
    }

    async reuqestDemo() {
        this.audioDemo = await this.demoRequester(
            pick(
                this.serviceDetail.data,
                ['lan', 'speed', 'intonation', 'volume', 'timbre', 'text']
            )
        );
    }

}
